import { render, staticRenderFns } from "./SignatureModal.vue?vue&type=template&id=3b67b382&scoped=true&"
import script from "./SignatureModal.vue?vue&type=script&lang=ts&"
export * from "./SignatureModal.vue?vue&type=script&lang=ts&"
import style0 from "./SignatureModal.vue?vue&type=style&index=0&id=3b67b382&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b67b382",
  null
  
)

export default component.exports